import { SpeedInsights } from '@vercel/speed-insights/react';
import useTemplatedRoute from './useTemplatedRoute';

// Must be rendered inside <RouterProvider> so useTemplatedRoute can read the router's matches.
export default function SpeedInsightsWithRoute() {
  const route = useTemplatedRoute();
  return <SpeedInsights route={route} />;
}
